import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  defaults,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
      display: false,
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
  },
};
defaults.font.family = "normalFont";
defaults.font.size = 14;
defaults.scale.ticks.precision = 0;

const AppLineChart = ({ dataset, options: customOptions }) => {
  return (
    <Line
      style={{
        borderRadius: 10,
        maxHeight: 400,
      }}
      options={customOptions || options}
      data={dataset}
    />
  );
};

export default AppLineChart;
